import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { OtpPopupComponent } from 'src/app/otp-popup/otp-popup.component';
import { CommonService } from '../../services/common.service';
import { DOCUMENT, CommonModule } from '@angular/common';
import { AnalyticsService } from '../../services/analytics.service';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NeedHelpPopupOverComponent } from '../need-help-popup-over/need-help-popup-over.component';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
    imports: [MatIconModule, CommonModule, FlexLayoutModule]
})
export class HeaderComponent implements OnInit {
    currentAWB: any = null;
    currentCustomerConatct: any = null;
    routeData: any;

    @ViewChild('helpPopup') helpPopupRef!: ElementRef;
    @ViewChild('triggerRef') triggerRef!: ElementRef;

    showHelpPopup = false;
    private globalClickUnlistener?: () => void;

    constructor(
        private router: Router,
        public dialog: MatDialog,
        public commonService: CommonService,
        public analyticServ: AnalyticsService,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document
    ) { }

    ngAfterViewInit(): void {
        this.globalClickUnlistener = this.renderer.listen('document', 'click', (event: Event) => {
            const clickedInsidePopup = this.helpPopupRef?.nativeElement?.contains(event.target);
            const clickedTrigger = this.triggerRef?.nativeElement?.contains(event.target);

            if (!clickedInsidePopup && !clickedTrigger && this.showHelpPopup) {
                this.showHelpPopup = false;
            }
        });
    }

    ngOnDestroy(): void {
        if (this.globalClickUnlistener) {
            this.globalClickUnlistener();
        }
    }


    ngOnInit(): void {

    }

    raiseTicket() {
        this.showHelpPopup = false;
        this.redirectToHelpCenter();
    }

    openNeedHelpPopOver() {
        if (window.innerWidth <= 768) {
            this.dialog.open(NeedHelpPopupOverComponent, {
                panelClass: 'help-dialog-bottom',
                width: '100%',
                maxWidth: '100%',
                position: { bottom: '0' },
                hasBackdrop: true,
                disableClose: true
            });
        } else {
            this.showHelpPopup = !this.showHelpPopup;
        }
    }

    redirectToHelpCenter() {
        this.router.navigate([`help-center/${this.commonService.getCookie('order_id')}/${this.commonService.getCookie('request_type')}`]);
    }

    redirectToShadowfax() {
        this.document.location.href = 'https://www.shadowfax.in/';
    }

    checkForHref() {
        if (this.router.routerState.snapshot.url == "/" || this.router.routerState.snapshot.url.indexOf('Connect') != -1) {
            return true;
        } else {
            return false;
        }
    }

    checkForLandingPage() {
        if (this.router.routerState.snapshot.url == "/") {
            return true;
        } else {
            return false;
        }
    }

    openOTPPopupWithParam() {
        if (!this.commonService.getCookie('sfxTrackToken')) {

            this.currentAWB = this.commonService.getCookie('awb_number');
            this.currentCustomerConatct = this.commonService.getCookie('maskedCustomerNumber');

            if (!this.currentAWB) {
                return
            }
            this.analyticServ.sendEvent('need_help_clicked', {
                pageName: this.router.routerState.snapshot.url.split('/')[1],
                trackingID: this.currentAWB,
                type: this.commonService.getCookie('request_type')
            })

            let custObj = {
                awb_number: this.currentAWB,
                customer_number: this.currentCustomerConatct
            }

            let dialogRef = this.dialog.open(OtpPopupComponent, {
                disableClose: true,
                data: {
                    awb_number: custObj.awb_number,
                    customer_number: custObj.customer_number,
                },
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this.commonService.showSuccess("Verification Successful");
                    this.openNeedHelpPopOver();
                }
            });
        } else {
            this.analyticServ.sendEvent('need_help_clicked', {
                pageName: this.router.routerState.snapshot.url.split('/')[1],
                trackingID: this.currentAWB,
                type: this.commonService.getCookie('request_type')
            })
            this.openNeedHelpPopOver();
        }

    }
}
